export default __webpack_public_path__ + "static/media/planty_demo.814aad44.png";